// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const versionInfo = {
    "version": "1.0.0",
    "hash": "97988668",
    "commitDate": "1788301497"
};
/* tslint:enable */
